import React from 'react'
import PageLoader from '../components/PageLoader'
import PrivateRoute from './PrivateRoute'

type Props = {
    children: React.ReactNode
}

function RouteWrapper({ children }: Props) {
    return (
        <PrivateRoute>
            <PageLoader>
                {children}
            </PageLoader>
        </PrivateRoute>
    )
}

export default RouteWrapper